import { createContext, useContext } from "react";

export type FullscreenLoaderProcessProps = {
  processId?: string,
  description?: string,
  progress?: number,
}

export type FullscreenLoaderContextProps = {
  processes: FullscreenLoaderProcessProps[],
  push: (props: FullscreenLoaderProcessProps) => FullscreenLoaderProcessProps,
  remove: (processId: string | undefined) => void,
}

export const FullscreenLoaderContext = createContext<FullscreenLoaderContextProps>({
  processes: [],
  remove: processId => {
    throw new Error("Not implemented");
  },
  push: props => {
    throw new Error("Not implemented");
  },
});

export const useFullscreenLoader = () => useContext(FullscreenLoaderContext);

export default FullscreenLoaderContext;

